module.exports = __webpack_public_path__ + "img/cover-4.03514d6a.jpg";